import {Component} from 'react';
import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import mediaQueries from './query';

/**
 * This is a container component that is capable of listening to media query
 * changes. The screen size is then updated in the Redux store to be accessible by other components.
 */
export class ResponsiveListener extends Component {
  componentDidMount() {
    // Set up media query listeners
    this.listeners = [];
    for (const size in mediaQueries) {
      const mediaQueryList = window.matchMedia(mediaQueries[size]);
      const boundListener = this.screenSizeListener.bind(this, size);
      mediaQueryList.addListener(boundListener);

      // Initialize once based on value of 'matches'
      if (mediaQueryList.matches) {
        this.updateScreenSize(size);
      }

      // Save these to use for cleanup later
      this.listeners.push({
        mediaQueryList,
        boundListener,
      });
    }
  }

  componentWillUnmount() {
    // Cleanup media query listeners
    /* istanbul ignore else */
    if (this.listeners) {
      this.listeners.forEach((listener) => {
        listener.mediaQueryList.removeListener(listener.boundListener);
      });
    }
  }

  updateScreenSize(size) {
    const {updateScreenSize} = this.props;
    /* istanbul ignore else */
    if (updateScreenSize) {
      updateScreenSize(size);
    }
  }

  /**
   * Generic listener for the media query changes
   */
  screenSizeListener(size, event) {
    /* istanbul ignore else */
    if (event.matches) {
      this.updateScreenSize(size);
    }
  }

  render() {
    const {children} = this.props;

    // Just render its children
    return children;
  }
}

ResponsiveListener.propTypes = {
  children: PropTypes.node,
  updateScreenSize: PropTypes.func,
};

export default connect(controller)(ResponsiveListener);
export {mediaQueries};
